export default "__VITE_PUBLIC_ASSET__4771ca1a__"